/* eslint-disable newline-before-return */
import { Select } from "@totalenergiescode/mobility-business-rev-design-system";
import { Controller, FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ControlledSelectProps } from "@/components/shared/ControlledSelect/types";

import {
  StyledMultipleValueContainer,
  StyledMultipleValueItem,
  StyledSelectWrapper,
} from "./styles";

export const ControlledSelect = <T extends FieldValues>({
  name,
  control,
  namespace,
  selectProps,
}: ControlledSelectProps<T>) => {
  const { t } = useTranslation(namespace);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const isError =
          typeof selectProps.error !== "undefined"
            ? selectProps.error
            : !!fieldState.error;
        const errorMessage = selectProps.errorMessage
          ? selectProps.errorMessage
          : fieldState.error?.message && namespace
            ? t(fieldState.error.message, { ns: namespace })
            : undefined;

        const renderValue = selectProps.multiple
          ? (selected: unknown) => {
              if (!Array.isArray(selected)) return "";
              const selectedValues = selected as (string | number)[];
              const options =
                "options" in selectProps ? selectProps.options : undefined;
              return (
                <StyledMultipleValueContainer>
                  {selectedValues.map((value, index) => {
                    const option = options?.find((opt) => opt.value === value);
                    return (
                      <StyledMultipleValueItem key={index}>
                        {option?.label || String(value)}
                      </StyledMultipleValueItem>
                    );
                  })}
                </StyledMultipleValueContainer>
              );
            }
          : undefined;

        return (
          <StyledSelectWrapper>
            <Select
              {...selectProps}
              value={field.value ?? (selectProps.multiple ? [] : "")}
              onChange={(event, child) => {
                field.onChange(event);
                selectProps.onChange?.(event, child);
              }}
              error={isError}
              errorMessage={errorMessage}
              renderValue={renderValue}
            />
          </StyledSelectWrapper>
        );
      }}
    />
  );
};
